export { default } from './B2BGiftVoucher';
